export function getNormalizedBaseUrl(baseUrl: string): string {
  return baseUrl.trim().replace(/\/+$/, '');
}
